/*
 * Rewrites BSS B2B Solution's own minimum-order warning modal (#modalWarningOL)
 * with the theme's per-rule copy instead of the app's default: one combined
 * English sentence per rule TYPE, mixing every unmet amount rule into a
 * single line ("$200.00 $20.00") that reads as a typo. See
 * snippets/b2b-modal-skin.liquid for why only CSS was possible before this —
 * this reuses the exact rule-evaluation data assets/b2b-cart-progress.js
 * already builds for the cart bar (window.themeB2BCartProgress), rather than
 * trying to parse BSS's own text.
 *
 * BSS raises the modal by appending it straight to document.body with no
 * event or framework hook to tap into, so a MutationObserver on body is the
 * only way to know it just appeared.
 */
(function () {
  'use strict';

  // Last-resort copy for a minimum-order rule that isn't in
  // b2b-cart-progress.js's RULE_MESSAGES yet (e.g. a new tier just added in
  // the BSS admin) — same Spanish-in-JS convention that map already uses,
  // not a locale key, so this never depends on a translation being added
  // first.
  var FALLBACK_AMOUNT = 'El monto de tu pedido debe ser mayor o igual a %%minimum%%.';
  var FALLBACK_QUANTITY = 'Debes elegir al menos %%minimum%% producto(s).';

  function readJsonScript(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function pendingEntries(progress, context) {
    // From the live session, not from the context blob: that blob re-renders
    // with its section, and section markup never branches on `customer` here.
    var customerTags = window.themeB2BSession ? window.themeB2BSession.tags : [];
    if (!customerTags.length) return [];

    var rules = progress.readMinimumRules(customerTags);
    if (!rules.length) return [];

    return rules
      .map(function (rule) {
        return progress.evaluateRule(rule, context.lines || []);
      })
      .filter(function (entry) {
        return entry && !entry.met;
      });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function messageFor(progress, entry, moneyFormat) {
    var custom = progress.customRuleMessage(entry, moneyFormat);
    if (custom) return custom;

    return progress.interpolate(entry.isAmount ? FALLBACK_AMOUNT : FALLBACK_QUANTITY, {
      minimum: entry.isAmount
        ? progress.formatMoney(entry.rule.minimum * 100, moneyFormat)
        : String(entry.rule.minimum),
    });
  }

  function rowHtml(progress, entry, moneyFormat) {
    return (
      '<li class="b2b-modal-warning-row">' +
      '<span class="b2b-modal-warning-scope">' + escapeHtml(entry.scope.join(', ')) + '</span>' +
      '<span class="b2b-modal-warning-message">' + escapeHtml(messageFor(progress, entry, moneyFormat)) + '</span>' +
      '</li>'
    );
  }

  function rewrite(modal) {
    var progress = window.themeB2BCartProgress;
    var context = readJsonScript(document.querySelector('[data-b2b-modal-context]'));
    if (!progress || !context) return;

    var entries = pendingEntries(progress, context);
    if (!entries.length) return; // nothing trusted to show; leave BSS's own copy as-is

    var body = modal.querySelector('.bss-modal-amo-body');
    if (!body) return;

    var title = modal.querySelector('.bss-modal-amo-title');
    if (title) title.textContent = 'Casi listo';

    body.innerHTML =
      '<ul class="b2b-modal-warning-list">' +
      entries
        .map(function (entry) {
          return rowHtml(progress, entry, context.moneyFormat);
        })
        .join('') +
      '</ul>';
  }

  function watch() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var modal =
            node.id === 'modalWarningOL'
              ? node
              : node.querySelector && node.querySelector('#modalWarningOL');
          if (modal) rewrite(modal);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
